import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _store = /*#__PURE__*/new WeakMap();
export class PanelStore {
  constructor(manifestHelpers) {
    this.manifestHelpers = manifestHelpers;
    /**
     * we store panel factories instead of a React component,
     * since panels are stored per type,
     * but opened per component (editor pointer), so we build a panel for a specific component
     */
    _classPrivateFieldInitSpec(this, _store, new Map());
  }
  getAll() {
    return Object.fromEntries(_classPrivateFieldGet(_store, this).entries());
  }
  getPanelFactory(compType, actionName) {
    var _classPrivateFieldGet2;
    return (_classPrivateFieldGet2 = _classPrivateFieldGet(_store, this).get(compType)) == null ? void 0 : _classPrivateFieldGet2[actionName];
  }
  getPanel(compType, actionName) {
    var _this$getPanelFactory;
    return ((_this$getPanelFactory = this.getPanelFactory(compType, actionName)) == null ? void 0 : _this$getPanelFactory()) ?? null;
  }
  setPanel(compType, actionName, panel) {
    const panels = _classPrivateFieldGet(_store, this).get(compType) ?? {};
    _classPrivateFieldGet(_store, this).set(compType, {
      ...panels,
      [actionName]: panel
    });
  }
  getPanelByEditorPointer(editorPointer, actionName) {
    const elementPath = (editorPointer.innerElementPath ?? []).slice(1);
    const compType = this.manifestHelpers.getCompType(editorPointer);
    const panelFactory = elementPath.length ? this.getPanelFactory(PanelStore.getPanelId(compType, elementPath), actionName) : this.getPanelFactory(compType, actionName);
    if (!panelFactory) {
      return null;
    }
    return panelFactory(editorPointer);
  }
  setPanelByEditorPointer(editorPointer, actionName, panel) {
    return this.setPanel(this.manifestHelpers.getCompType(editorPointer), actionName, panel);
  }
}
_defineProperty(PanelStore, "getPanelId", (compType, path) => {
  return `${compType}_${path.join('.')}`;
});
//# sourceMappingURL=PanelStore.js.map